// src/components/Header.js
import React from "react";
import "./Header.css"; // Assuming styles are in Header.css

function Header() {
  return (
    <header className="header-container">
      <div className="header-content">
        <div className="header-content-wrapper">
          <div className="welcome-text">Welcome to</div>
          <img
            src="/mckennaOasisLogo.png"
            alt="McKenna Oasis Logo"
            className="logo"
          />
          <div className="welcome-text">the Oasis!</div>
        </div>
        <div className="header-divider"></div>
      </div>
    </header>
  );
}

export default Header;
